/* eslint-disable max-lines */
import { API } from 'aws-amplify';
import dayjs from 'dayjs';
import { extractErrorMessageString } from 'src/shared/helpers/string-helpers';

import {
  JoiPublicAppSaveEssay,
  JoiPublicAppSaveFinancial,
  JoiPublicAppSaveProfiles,
  JoipublicAppSaveSignature,
  JoiPublicAppSaveTranscript,
  JoiPublicAppSaveTtpf,
  JoiPublicProfileSaveChild,
  JoiPublicProfileSaveParent
} from './scholarship.joi';
import {
  EnumAppDocFormat,
  EnumAppDocType,
  EnumAppSignatureType,
  EnumFileStatus,
  EnumProfileRelation,
  EnumSections,
  MAppEssay,
  MAppSignature,
  MAppTranscript,
  MProfile
} from './scholarship.models';
import ScholarshipTypes from './scholarship.types';

export const applicationSetField = (id, section, field, value) => ({
  type: ScholarshipTypes.APPLICATION_SET_FIELD,
  payload: { id, section, field, value }
});

export const applicationCreate = (userId, parents) => ({
  type: ScholarshipTypes.APPLICATION_CREATE,
  payload: { userId, parents }
});

export const fileDeleteStart = () => ({
  type: ScholarshipTypes.APPLICATION_DELETE_FILE_START
});

export const fileDeleteSuccess = (payload) => ({
  type: ScholarshipTypes.APPLICATION_DELETE_FILE_SUCCESS,
  payload: payload
});

export const fileDeleteFailure = (payload) => ({
  type: ScholarshipTypes.APPLICATION_DELETE_FILE_FAILURE,
  payload: payload
});

export const applicationResetFile = (docFormat: EnumAppDocFormat, docType: EnumAppDocType) => {
  return async (dispatch) => {
    let payload = {
      docContent: undefined,
      docFormat,
      docStatus: undefined,
      docType
    };
    dispatch(fileDeleteSuccess(payload));

    return true;
  };
};

/* eslint-disable max-params */
export const applicationDeleteFile = (
  docFormat: EnumAppDocFormat,
  docType: EnumAppDocType,
  docStatus: EnumFileStatus,
  body: any,
  id: string,
  signature?: any
) => {
  return async (dispatch) => {
    dispatch(fileDeleteStart());
    try {
      await API.del('service-mtpf', `/file`, { body: body });
      let payload;
      if (signature) {
        payload = {
          docFormat,
          docType,
          docStatus,
          docContent: undefined,
          filePath: undefined,
          essaySignature: signature
        };
      } else {
        payload = {
          docFormat,
          docType,
          docStatus,
          docContent: undefined,
          filePath: undefined
        };
      }
      dispatch(fileDeleteSuccess(payload));

      return true;
    } catch (error) {
      console.log('applicationDeleteFile error');
      console.error(error);
      dispatch(fileDeleteFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};
/* eslint-enable max-params */

export const applicationSaveFile = (
  saveFiles: MAppEssay | MAppTranscript | MAppSignature | Record<string, unknown>,
  section: EnumAppDocType
) => {
  let actionPayload = { payload: saveFiles };

  switch (section) {
    case EnumAppDocType.ESSAY:
      actionPayload['type'] = ScholarshipTypes.APPLICATION_SAVE_ESSAY;
      break;
    case EnumAppDocType.TRANSCRIPT:
      actionPayload['type'] = ScholarshipTypes.APPLICATION_SAVE_TRANSCRIPT;
      break;
    case EnumAppDocType.SIGNATURE:
      actionPayload['type'] = ScholarshipTypes.APPLICATION_SAVE_SIGNATURE;
      break;
  }

  return actionPayload;
};

export const deleteApplicationStart = () => ({
  type: ScholarshipTypes.DELETE_APPLICATION_START
});

export const deleteApplicationFailure = (error) => ({
  type: ScholarshipTypes.DELETE_APPLICATION_FAILURE,
  payload: error
});

export const deleteApplicationSuccess = (id) => ({
  type: ScholarshipTypes.DELETE_APPLICATION_SUCCESS,
  payload: id
});

export const fetchApplicationStart = () => ({
  type: ScholarshipTypes.FETCH_APPLICATION_START
});

export const fetchApplicationSuccess = () => ({
  type: ScholarshipTypes.FETCH_APPLICATION_SUCCESS
});

export const fetchApplicationsStart = () => ({
  type: ScholarshipTypes.FETCH_APPLICATIONS_START
});

export const fetchApplicationFilesStart = () => ({
  type: ScholarshipTypes.FETCH_APPLICATION_FILES_START
});

export const fetchApplicationFilesSuccess = (data) => ({
  type: ScholarshipTypes.FETCH_APPLICATION_FILES_SUCCESS,
  payload: data
});

export const fetchApplicationFilesFailure = (error) => ({
  type: ScholarshipTypes.FETCH_APPLICATION_FILES_FAILURE,
  payload: error
});

export const fetchApplicationsSuccess = (data) => ({
  type: ScholarshipTypes.FETCH_APPLICATIONS_SUCCESS,
  payload: data
});

export const fetchApplicationsFailure = (error) => ({
  type: ScholarshipTypes.FETCH_APPLICATIONS_FAILURE,
  payload: error
});

export const fetchProfilesStart = () => ({
  type: ScholarshipTypes.FETCH_PROFILES_START
});

export const fetchProfilesSuccess = (data) => ({
  type: ScholarshipTypes.FETCH_PROFILES_SUCCESS,
  payload: data
});

export const fetchProfilesFailure = (error) => ({
  type: ScholarshipTypes.FETCH_PROFILES_FAILURE,
  payload: error
});

export const profileSetField = (id, field, value) => ({
  type: ScholarshipTypes.PROFILE_SET_FIELD,
  payload: { id, field, value }
});

export const profileCreate = (profileType) => ({
  type: ScholarshipTypes.PROFILE_CREATE,
  payload: profileType
});

export const profileDelete = (id) => ({
  type: ScholarshipTypes.PROFILE_DELETE,
  payload: id
});

export const reduxLogout = () => ({
  type: ScholarshipTypes.USER_LOGOUT
});

export const resendEmailStart = () => ({
  type: ScholarshipTypes.RESEND_EMAIL_START
});

export const resendEmailClose = () => ({
  type: ScholarshipTypes.RESEND_EMAIL_CLOSE
});

export const resendEmailFailure = (error) => ({
  type: ScholarshipTypes.RESEND_EMAIL_FAILURE,
  payload: error
});

export const resendEmailSuccess = () => ({
  type: ScholarshipTypes.RESEND_EMAIL_SUCCESS
});

export const resendEmailCloseDialog = () => ({
  type: ScholarshipTypes.RESEND_EMAIL_CLOSE_DIALOG
});

export const saveSectionStart = () => ({
  type: ScholarshipTypes.SECTION_SAVE_START
});

export const saveSectionTTPF = (data) => ({
  type: ScholarshipTypes.SECTION_SAVE_TTPF,
  payload: data
});

export const saveSectionEssay = (data) => ({
  type: ScholarshipTypes.SECTION_SAVE_ESSAY,
  payload: data
});

export const saveSectionSuccess = (section, record) => ({
  type: ScholarshipTypes.SECTION_SAVE_SUCCESS,
  payload: { section, record }
});

export const saveSectionFailure = (error) => ({
  type: ScholarshipTypes.SECTION_SAVE_FAILURE,
  payload: error
});

export const saveProfileStart = () => ({
  type: ScholarshipTypes.PROFILE_SAVE_START
});

export const saveProfileSuccess = (data) => ({
  type: ScholarshipTypes.PROFILE_SAVE_SUCCESS,
  payload: data
});

export const saveProfileFailure = (error) => ({
  type: ScholarshipTypes.PROFILE_SAVE_FAILURE,
  payload: error
});

export const saveSignatureStart = () => ({
  type: ScholarshipTypes.SIGNATURE_SAVE_START
});

export const saveSignatureSuccess = () => ({
  type: ScholarshipTypes.SIGNATURE_SAVE_SUCCESS
});

export const saveSignatureFailure = (error) => ({
  type: ScholarshipTypes.SIGNATURE_SAVE_FAILURE,
  payload: error
});

export const setStep = (oldStep: number | undefined, newStep: number) => ({
  type: ScholarshipTypes.SET_STEP,
  payload: { oldStep, newStep }
});

export const setStepsCompleted = (value: object) => ({
  type: ScholarshipTypes.SET_STEPS_COMPLETED,
  payload: value
});

export const setApplicationId = (value: string) => ({
  type: ScholarshipTypes.SET_APPLICATION_ID,
  payload: value
});

export const signatureUpsert = (data) => ({
  type: ScholarshipTypes.SIGNATURE_UPSERT,
  payload: data
});

export const signatureDelete = (data) => ({
  type: ScholarshipTypes.SIGNATURE_DELETE,
  payload: data
});

export const addPurchaserFailure = (error) => ({
  type: ScholarshipTypes.ADD_PURCHASER_FAILURE,
  payload: error
});

export const deleteApplicationAsync = (id: string) => {
  return async (dispatch) => {
    dispatch(deleteApplicationStart());
    try {
      let result = await API.del('service-mtpf', `/delete/application/${id}`, { body: { confirm: 'permanently delete' } });
      console.log(result);
      if (result.success) {
        dispatch(deleteApplicationSuccess(id));

        return true;
      } else if (result.error) {
        dispatch(deleteApplicationFailure(result.error));
      }
    } catch (error) {
      console.log(error);
      dispatch(deleteApplicationFailure(extractErrorMessageString(error)));

      return false;
    }
    dispatch(deleteApplicationFailure('Unknown error'));

    return false;
  };
};

export const deleteProfileAsync = (data: MProfile) => {
  return async (dispatch) => {
    let url;
    dispatch(saveProfileStart());

    try {
      switch (data.relationship) {
        case EnumProfileRelation.FATHER:
        case EnumProfileRelation.MOTHER:
        case EnumProfileRelation.OTHER:
          url = `/profile/parent/${data.id}`;
          break;
        default:
          url = `/profile/child/${data.id}`;
          break;
      }
      let results = await API.del('service-mtpf', url, {});
      console.error(results);
      dispatch(profileDelete(data.id));

      return true;
    } catch (error) {
      console.error(error);
      dispatch(saveProfileFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const fetchApplicationReopenAsync = (id: string) => {
  return async (dispatch) => {
    dispatch(fetchApplicationStart());
    try {
      await API.post('service-mtpf', '/application/reopen', { body: { id: id } });

      return true;
    } catch (error) {
      dispatch(fetchApplicationsFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const fetchApplicationAsync = (id: string) => {
  return async (dispatch) => {
    dispatch(fetchApplicationStart());
    try {
      let results = await API.get('service-mtpf', `/application/${id}`, {});
      console.log('fetchApplicationAsync results');
      console.log(results);
      for (const section of Object.keys(results.data)) {
        let record = { id, section, data: results.data[section] };
        // dispatch(saveSectionSuccess(section, { id, section, data }));
        dispatch(saveSectionSuccess(section, record));
        if (section === 'meta') {
          dispatch(setStepsCompleted(results.data['meta'].progress));
        }
      }
      dispatch(fetchApplicationSuccess());

      return true;
    } catch (error) {
      console.log(error);
      dispatch(fetchApplicationsFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const fetchApplicationsAsync = () => {
  return async (dispatch) => {
    dispatch(fetchApplicationsStart());
    try {
      let results;
      results = await API.get('service-mtpf', '/profiles/family', {});
      dispatch(fetchProfilesSuccess(results.data));
      results = await API.get('service-mtpf', '/list', {});
      dispatch(fetchApplicationsSuccess(results.data));
    } catch (error) {
      dispatch(fetchApplicationsFailure(extractErrorMessageString(error)));
    }
  };
};

export const fetchApplicationFilesAsync = (id: string, filter?: string) => {
  return async (dispatch) => {
    dispatch(fetchApplicationFilesStart());
    try {
      let path = `/files/${id}`;
      if (filter) {
        path = path + `?filter=${filter}`;
      }
      let results = await API.get('service-mtpf', path, {});
      dispatch(fetchApplicationFilesSuccess(results.data));
    } catch (error) {
      dispatch(fetchApplicationFilesFailure(extractErrorMessageString(error)));
    }
  };
};

export const completeApplicationAsync = (applicationId: string, data: any) => {
  return async (dispatch) => {
    const url = `/complete`;
    dispatch(saveSectionStart());

    try {
      let body = {
        data: [
          {
            ...data
          }
        ],
        id: applicationId,
        section: 'signatures'
      };

      // duplicate the parent signature to send both it
      // and a copy of itself with the signature type
      // CERTIFICATION
      body.data.push({ ...body.data[0] });
      body.data[0].signatureType = EnumAppSignatureType.CERTIFICATION;

      body = await JoipublicAppSaveSignature.validateAsync(body);
      const results = await API.post('service-mtpf', url, { body: body });
      let newId = results.data.meta.id;

      for (const rSection of Object.keys(results.data)) {
        if (rSection === 'meta') {
          dispatch(saveSectionSuccess(rSection, { newId, section: rSection, data: results.data[rSection] }));
        } else {
          dispatch(signatureUpsert(results.data[rSection]));
        }
      }

      return true;
    } catch (error) {
      console.log('completeApplicationAsync error');
      console.error(error);
      dispatch(saveProfileFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const deleteSignatureAsync = (applicationId: string, data: MAppSignature) => {
  return async (dispatch) => {
    dispatch(saveProfileStart());
    let body = {
      appId: applicationId,
      signatureType: data.signatureType,
      signatureId: data.signatureId
    };
    try {
      await API.del('service-mtpf', '/delete/mention', { body: body });
      dispatch(signatureDelete(data.signatureId));

      return true;
    } catch (error) {
      console.log('deleteSignature error');
      dispatch(saveProfileFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const saveApplicationAsync = (id: string, section: EnumSections, stateElement, progress) => {
  return async (dispatch, getState) => {
    let url = `/save`;
    dispatch(saveSectionStart());
    let data = stateElement;
    try {
      switch (section) {
        case EnumSections.META:
          data = await JoiPublicAppSaveProfiles.validateAsync(stateElement);

          // remove the lastUpdated property is it was used for validation but won't be sent to the API.
          delete data.lastUpdated;
          break;
        case EnumSections.TTPF:
          data = await JoiPublicAppSaveTtpf.validateAsync(stateElement);
          break;
        case EnumSections.FINANCIAL:
          data = await JoiPublicAppSaveFinancial.validateAsync(stateElement);
          break;
        case EnumSections.ESSAY: {
          // Check if the agreement signature is in a signed state. If not, throw error because it needs to be.
          const agreementSignature = getState().scholarship.application.signatures.find(
            (item: MAppSignature) => item.signatureType === EnumAppSignatureType.AGREEMENT
          );
          if (!agreementSignature?.signed) {
            const customError = new Error('You must sign the agreement before saving this page.');
            throw customError;
          } else {
            stateElement['essaySignature'] = agreementSignature;
          }
          data = await JoiPublicAppSaveEssay.validateAsync(stateElement);
          break;
        }
        case EnumSections.TRANSCRIPT:
          data = await JoiPublicAppSaveTranscript.validateAsync(stateElement);
          break;
        default:
          break;
      }
      let results = await API.post('service-mtpf', url, { body: { id, section, data, progress } });
      if (section === EnumSections.META) {
        let newId = results.data.meta.id;
        for (const rSection of Object.keys(results.data)) {
          if (rSection === 'meta') {
            dispatch(saveSectionSuccess(rSection, { newId, section: rSection, data: results.data[rSection] }));
          } else {
            // When the meta section is saved a new application is created.
            // Along with the meta object, 2 signatures are created that are required to complete the application
            // agreement, which is signed on the essay page
            // parent, which is the final signature on the complete page
            results.data[rSection].forEach((d) => dispatch(signatureUpsert(d)));
          }
        }

        return newId;
      } else if (section === EnumSections.TTPF || section === EnumSections.ESSAY) {
        for (const rSection of Object.keys(results.data)) {
          if (rSection === 'ttpf') {
            // The purchaser signature is created before the TTPF section is saved.
            // If the signature was created, but the user then switched the radio button to say they owned the account
            // we need to remove that signature from the database and redux.
            if (!data.notParentTtpfAccount) {
              const purchaserSignature = getState().scholarship.application.signatures.find(
                (item: MAppSignature) => item.signatureType === EnumAppSignatureType.PURCHASER
              );
              if (purchaserSignature) {
                dispatch(deleteSignatureAsync(id, purchaserSignature));
              }
            }
            dispatch(saveSectionSuccess(section, { id, section, data }));
          } else if (rSection === 'essay') {
            dispatch(saveSectionSuccess(section, { id, section, data }));
          } else {
            dispatch(signatureUpsert(results.data[rSection]));
          }
        }

        return id;
      } else {
        dispatch(saveSectionSuccess(section, { id, section, data }));

        return id;
      }
    } catch (error) {
      console.log('saveApplicationAsync error');
      console.log(error);
      dispatch(saveProfileFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const saveSignatureAsync = (applicationId: string, data: any) => {
  return async (dispatch) => {
    const url = `/save`;

    let body = {
      section: 'signatures',
      data: [data],
      id: applicationId
    };

    try {
      body = await JoipublicAppSaveSignature.validateAsync(body);
    } catch (error) {
      console.log(error);
      dispatch(saveSignatureFailure(extractErrorMessageString(error)));

      return false;
    }

    dispatch(saveSignatureStart());

    try {
      let results = await API.post('service-mtpf', url, { body: body });
      results.data.forEach((item) => {
        console.log(item);
        dispatch(signatureUpsert(item));
      });
      dispatch(saveSignatureSuccess());

      return true;
    } catch (error) {
      console.log('loadDataAsync error');
      console.error(error);
      dispatch(saveSignatureFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const saveProfileAsync = (data: MProfile, progress) => {
  return async (dispatch) => {
    const url = `/save`;
    let section;
    let id = data.id;
    let saveDate;
    dispatch(saveProfileStart());
    try {
      if (window.location.pathname.includes('parent')) {
        data = await JoiPublicProfileSaveParent.validateAsync(data);
        section = EnumSections.PARENT;
      } else {
        data = await JoiPublicProfileSaveChild.validateAsync(data);
        section = EnumSections.CHILD;
        saveDate = data.dob;
        // @ts-ignore - Joi schema allows Date object before formatting to API date string.
        data.dob = dayjs(data.dob).format('YYYY-MM-DD');
      }
      let results = await API.post('service-mtpf', url, { body: { id, section, data, progress } });
      // data.id = results.data;
      if (saveDate) {
        results.data.dob = saveDate;
      }
      dispatch(saveProfileSuccess(results.data));
      dispatch(fetchApplicationsAsync());

      return true;
    } catch (error) {
      console.log('loadDataAsync error');
      console.error(error);
      dispatch(saveProfileFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};

export const resendEmailAsync = (row) => {
  return async (dispatch) => {
    dispatch(resendEmailStart());
    let body = {
      id: row.id,
      signatureType: row.signatureType,
      signatureId: row.signatureId
    };

    try {
      await API.post('service-mtpf', '/resend', { body: body });
      dispatch(resendEmailSuccess());

      return true;
    } catch (error) {
      console.log(error);
      dispatch(resendEmailFailure(extractErrorMessageString(error)));

      return false;
    }
  };
};
